import { types } from '../actions/types';

const INITIAL_STATE = {
    shouldBlur: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.BLUR_PAGE:
            return {
                ...state, shouldBlur: action.payload
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/js/reducers/blur-reducer.js